import { getPathDatabaseByRole } from "./auth";
import types from "../types";
import { fetchMergedCreditPricingForAgency } from "../utils/creditActionCosts";

/**
 * Loads `agencies/${agencyID}/pricingVersion`, `agencies/${agencyID}/creditActionCosts`, merges tier base + overrides;
 * also resolves credit purchase bundles for the same version.
 * Call after auth (e.g. from AppRouter getInitialData).
 */
export const startLoadCreditActionCosts = () => async (dispatch) => {
  const { agencyID } = dispatch(getPathDatabaseByRole());
  const {
    creditActionCosts,
    creditPurchasePackages,
    videoPurchasePackages,
    creditPricingVersion,
    adSpendFeePercentage,
  } = await fetchMergedCreditPricingForAgency(agencyID);

  dispatch({
    type: types.SET_CREDIT_ACTION_COSTS,
    payload: {
      creditActionCosts,
      creditPurchasePackages,
      videoPurchasePackages,
      creditPricingVersion,
      adSpendFeePercentage,
    },
  });
};
